// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Mobile Navigation Animations & Swipe Support */

/* Smooth page transitions with swipe animations */
@keyframes slide-in-right {
  from {
    opacity: 0;
    transform: translateX(100%);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes slide-out-left {
  from {
    opacity: 1;
    transform: translateX(0);
  }
  to {
    opacity: 0;
    transform: translateX(-100%);
  }
}

@keyframes slide-in-left {
  from {
    opacity: 0;
    transform: translateX(-100%);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes slide-out-right {
  from {
    opacity: 1;
    transform: translateX(0);
  }
  to {
    opacity: 0;
    transform: translateX(100%);
  }
}

/* Bottom Sheet Animation */
@keyframes slide-up-drawer {
  from {
    opacity: 0;
    transform: translateY(100%);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slide-down-drawer {
  from {
    opacity: 1;
    transform: translateY(0);
  }
  to {
    opacity: 0;
    transform: translateY(100%);
  }
}

/* Navigation bar indicator dots animation */
@keyframes pulse-indicator {
  0%, 100% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.2);
    opacity: 0.8;
  }
}

/* Icon scale animations for touch feedback */
@keyframes icon-press {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(0.95);
  }
  100% {
    transform: scale(1);
  }
}

/* Swipe hint appearance animation */
@keyframes fade-in-slide {
  from {
    opacity: 0;
    transform: translateX(-10px);
  }
  to {
    opacity: 0.6;
    transform: translateX(0);
  }
}

@keyframes fade-out-slide {
  from {
    opacity: 0.6;
    transform: translateX(0);
  }
  to {
    opacity: 0;
    transform: translateX(-10px);
  }
}

/* Mobile Navigation Styling - Floating Menu */

/* Hide scrollbar but keep scrolling functionality */
nav[role="navigation"] > div[class*="overflow-x-auto"] {
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
}

nav[role="navigation"] > div[class*="overflow-x-auto"]::-webkit-scrollbar {
  display: none; /* Chrome, Safari and Opera */
}

/* Floating Navigation Bar */
nav[role="navigation"] {
  animation: float-in-up 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
  transition: all 0.3s cubic-bezier(0.23, 1, 0.320, 1);
}

@keyframes float-in-up {
  from {
    opacity: 0;
    transform: translateY(20px) translateX(-50%);
  }
  to {
    opacity: 1;
    transform: translateY(0) translateX(-50%);
  }
}

/* Light Mode Mobile Nav */
:root:not(.dark) nav[role="navigation"] {
  background: linear-gradient(135deg,
    rgba(255, 255, 255, 0.85) 0%,
    rgba(250, 250, 248, 0.8) 100%
  );
  border: 1px solid rgba(217, 212, 207, 0.4);
  box-shadow:
    0 8px 32px rgba(0, 0, 0, 0.12),
    0 0 0 1px rgba(217, 212, 207, 0.2);
}

/* Navigation buttons with enhanced touch targets */
nav[role="navigation"] button {
  min-height: 44px; /* iOS minimum touch target */
  min-width: 44px;
  transition: all 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  position: relative;
  overflow: hidden;
  pointer-events: auto;
  touch-action: manipulation;
  cursor: pointer;
  border: none;
  background: transparent;
  padding: 0;
}

/* Touch feedback effect */
nav[role="navigation"] button:active {
  animation: icon-press 0.15s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

/* Navigation indicator dots */
nav[role="navigation"] .nav-indicator {
  transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

/* Swipe navigation hints (left/right chevrons) */
nav[role="navigation"] .swipe-hint {
  animation: fade-in-slide 0.3s ease-out;
}

nav[role="navigation"] .swipe-hint:disabled {
  animation: fade-out-slide 0.3s ease-out;
}

/* Bottom Sheet / More Apps Drawer */
.mobile-nav-sheet {
  animation: slide-up-drawer 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.mobile-nav-sheet.closing {
  animation: slide-down-drawer 0.3s ease-in;
}

/* Bottom Sheet Items Grid */
.mobile-nav-sheet-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1rem;
}

/* Responsive breakpoints for mobile navigation */
@media (max-width: 480px) {
  nav[role="navigation"] {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }

  .mobile-nav-sheet-grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 0.75rem;
  }
}

/* Prevent layout shift during safe area adjustment */
@supports (padding: max(0px)) {
  nav[role="navigation"] {
    padding-bottom: max(0.5rem, env(safe-area-inset-bottom));
  }

  .mobile-page-container {
    padding-bottom: max(5rem, calc(5rem + env(safe-area-inset-bottom)));
  }
}

/* Accessibility: Respect prefers-reduced-motion */
@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
    scroll-behavior: auto !important;
  }

  nav[role="navigation"] {
    transition: none;
  }

  nav[role="navigation"] button {
    transition: none;
  }
}

/* Touch device optimizations */
@media (hover: none) and (pointer: coarse) {
  nav[role="navigation"] button {
    /* Increase touch feedback visibility on touch devices */
    position: relative;
  }

  nav[role="navigation"] button::after {
    content: '';
    position: absolute;
    inset: 0;
    background: rgba(14, 165, 233, 0.05);
    border-radius: inherit;
    opacity: 0;
    transition: opacity 0.2s ease;
    pointer-events: none;
  }

  nav[role="navigation"] button:active::after {
    opacity: 1;
  }
}

/* High DPI/Retina display support */
@media (-webkit-min-device-pixel-ratio: 2) {
  nav[role="navigation"] {
    border-width: 0.5px;
  }
}

/* iPhone X and later notch support */
@supports (padding: max(0px)) {
  nav[role="navigation"] {
    padding-left: max(1rem, env(safe-area-inset-left));
    padding-right: max(1rem, env(safe-area-inset-right));
  }
}

/* Smooth scrolling for main content area */
.mobile-page-container {
  -webkit-overflow-scrolling: touch;
  scroll-behavior: smooth;
}

/* Page transition animations */
.page-transition-enter {
  animation: slide-in-right 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.page-transition-exit {
  animation: slide-out-left 0.3s ease-in;
}

.page-transition-enter-reverse {
  animation: slide-in-left 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.page-transition-exit-reverse {
  animation: slide-out-right 0.3s ease-in;
}

/* Landscape mode optimizations */
@media (max-height: 500px) {
  nav[role="navigation"] {
    padding: 0.5rem 1rem;
  }

  .mobile-nav-sheet {
    max-height: 80vh;
  }
}

/* Optimize for iPad and larger tablets */
@media (min-width: 768px) and (max-height: 1024px) {
  nav[role="navigation"] {
    padding: 0.75rem 1rem;
  }
}

/* Haptic feedback simulation (visual only, actual haptics via JavaScript if available) */
@keyframes haptic-feedback {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.8;
  }
}

.haptic-feedback {
  animation: haptic-feedback 0.1s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

/* Focus indicators for keyboard navigation */
nav[role="navigation"] button:focus-visible {
  outline: 2px solid var(--cyan-bright);
  outline-offset: -2px;
  box-shadow: 0 0 0 2px var(--bg-elevated), 0 0 0 4px var(--cyan-bright);
}

/* Dark mode - enhanced contrast for mobile nav */
.dark nav[role="navigation"] {
  border-top: 1px solid rgba(14, 165, 233, 0.2);
  border-bottom: 2px solid rgba(155, 139, 126, 0.25);
}

/* Performance optimization: Use will-change for animated elements */
nav[role="navigation"] button {
  will-change: transform, opacity;
}

nav[role="navigation"] .nav-indicator {
  will-change: width, background-color;
}

/* Prevent unnecessary repaints on scroll */
.mobile-page-container {
  contain: layout style paint;
}
`, "",{"version":3,"sources":["webpack://./src/styles/mobile.css"],"names":[],"mappings":"AAAA,iDAAiD;;AAEjD,kDAAkD;AAClD;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,wBAAwB;EAC1B;EACA;IACE,UAAU;IACV,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,wBAAwB;EAC1B;EACA;IACE,UAAU;IACV,2BAA2B;EAC7B;AACF;;AAEA,2BAA2B;AAC3B;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,wBAAwB;EAC1B;EACA;IACE,UAAU;IACV,2BAA2B;EAC7B;AACF;;AAEA,4CAA4C;AAC5C;EACE;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,qBAAqB;IACrB,YAAY;EACd;AACF;;AAEA,6CAA6C;AAC7C;EACE;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA,oCAAoC;AACpC;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,YAAY;IACZ,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,YAAY;IACZ,wBAAwB;EAC1B;EACA;IACE,UAAU;IACV,4BAA4B;EAC9B;AACF;;AAEA,8CAA8C;;AAE9C,oDAAoD;AACpD;EACE,qBAAqB,EAAE,YAAY;EACnC,wBAAwB,EAAE,gBAAgB;AAC5C;;AAEA;EACE,aAAa,EAAE,6BAA6B;AAC9C;;AAEA,4BAA4B;AAC5B;EACE,6DAA6D;EAC7D,oDAAoD;AACtD;;AAEA;EACE;IACE,UAAU;IACV,4CAA4C;EAC9C;EACA;IACE,UAAU;IACV,yCAAyC;EAC3C;AACF;;AAEA,0BAA0B;AAC1B;EACE;;;GAGC;EACD,0CAA0C;EAC1C;;sCAEoC;AACtC;;AAEA,mDAAmD;AACnD;EACE,gBAAgB,EAAE,6BAA6B;EAC/C,eAAe;EACf,yDAAyD;EACzD,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,0BAA0B;EAC1B,eAAe;EACf,YAAY;EACZ,uBAAuB;EACvB,UAAU;AACZ;;AAEA,0BAA0B;AAC1B;EACE,gEAAgE;AAClE;;AAEA,8BAA8B;AAC9B;EACE,yDAAyD;AAC3D;;AAEA,iDAAiD;AACjD;EACE,sCAAsC;AACxC;;AAEA;EACE,uCAAuC;AACzC;;AAEA,oCAAoC;AACpC;EACE,iEAAiE;AACnE;;AAEA;EACE,yCAAyC;AAC3C;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA,iDAAiD;AACjD;EACE;IACE,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;IACE,qCAAqC;IACrC,YAAY;EACd;AACF;;AAEA,qDAAqD;AACrD;EACE;IACE,wDAAwD;EAC1D;;EAEA;IACE,mEAAmE;EACrE;AACF;;AAEA,kDAAkD;AAClD;EACE;;;IAGE,qCAAqC;IACrC,uCAAuC;IACvC,sCAAsC;IACtC,gCAAgC;EAClC;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA,+BAA+B;AAC/B;EACE;IACE,wDAAwD;IACxD,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,oCAAoC;IACpC,sBAAsB;IACtB,UAAU;IACV,6BAA6B;IAC7B,oBAAoB;EACtB;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA,oCAAoC;AACpC;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA,qCAAqC;AACrC;EACE;IACE,kDAAkD;IAClD,oDAAoD;EACtD;AACF;;AAEA,2CAA2C;AAC3C;EACE,iCAAiC;EACjC,uBAAuB;AACzB;;AAEA,+BAA+B;AAC/B;EACE,gEAAgE;AAClE;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,+DAA+D;AACjE;;AAEA;EACE,uCAAuC;AACzC;;AAEA,iCAAiC;AACjC;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA,yCAAyC;AACzC;EACE;IACE,qBAAqB;EACvB;AACF;;AAEA,yFAAyF;AACzF;EACE;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE,oEAAoE;AACtE;;AAEA,6CAA6C;AAC7C;EACE,qCAAqC;EACrC,oBAAoB;EACpB,sEAAsE;AACxE;;AAEA,iDAAiD;AACjD;EACE,6CAA6C;EAC7C,kDAAkD;AACpD;;AAEA,oEAAoE;AACpE;EACE,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;AACtC;;AAEA,2CAA2C;AAC3C;EACE,2BAA2B;AAC7B","sourcesContent":["/* Mobile Navigation Animations & Swipe Support */\n\n/* Smooth page transitions with swipe animations */\n@keyframes slide-in-right {\n  from {\n    opacity: 0;\n    transform: translateX(100%);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n@keyframes slide-out-left {\n  from {\n    opacity: 1;\n    transform: translateX(0);\n  }\n  to {\n    opacity: 0;\n    transform: translateX(-100%);\n  }\n}\n\n@keyframes slide-in-left {\n  from {\n    opacity: 0;\n    transform: translateX(-100%);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n@keyframes slide-out-right {\n  from {\n    opacity: 1;\n    transform: translateX(0);\n  }\n  to {\n    opacity: 0;\n    transform: translateX(100%);\n  }\n}\n\n/* Bottom Sheet Animation */\n@keyframes slide-up-drawer {\n  from {\n    opacity: 0;\n    transform: translateY(100%);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes slide-down-drawer {\n  from {\n    opacity: 1;\n    transform: translateY(0);\n  }\n  to {\n    opacity: 0;\n    transform: translateY(100%);\n  }\n}\n\n/* Navigation bar indicator dots animation */\n@keyframes pulse-indicator {\n  0%, 100% {\n    transform: scale(1);\n    opacity: 1;\n  }\n  50% {\n    transform: scale(1.2);\n    opacity: 0.8;\n  }\n}\n\n/* Icon scale animations for touch feedback */\n@keyframes icon-press {\n  0% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(0.95);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n\n/* Swipe hint appearance animation */\n@keyframes fade-in-slide {\n  from {\n    opacity: 0;\n    transform: translateX(-10px);\n  }\n  to {\n    opacity: 0.6;\n    transform: translateX(0);\n  }\n}\n\n@keyframes fade-out-slide {\n  from {\n    opacity: 0.6;\n    transform: translateX(0);\n  }\n  to {\n    opacity: 0;\n    transform: translateX(-10px);\n  }\n}\n\n/* Mobile Navigation Styling - Floating Menu */\n\n/* Hide scrollbar but keep scrolling functionality */\nnav[role=\"navigation\"] > div[class*=\"overflow-x-auto\"] {\n  scrollbar-width: none; /* Firefox */\n  -ms-overflow-style: none; /* IE and Edge */\n}\n\nnav[role=\"navigation\"] > div[class*=\"overflow-x-auto\"]::-webkit-scrollbar {\n  display: none; /* Chrome, Safari and Opera */\n}\n\n/* Floating Navigation Bar */\nnav[role=\"navigation\"] {\n  animation: float-in-up 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);\n  transition: all 0.3s cubic-bezier(0.23, 1, 0.320, 1);\n}\n\n@keyframes float-in-up {\n  from {\n    opacity: 0;\n    transform: translateY(20px) translateX(-50%);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) translateX(-50%);\n  }\n}\n\n/* Light Mode Mobile Nav */\n:root:not(.dark) nav[role=\"navigation\"] {\n  background: linear-gradient(135deg,\n    rgba(255, 255, 255, 0.85) 0%,\n    rgba(250, 250, 248, 0.8) 100%\n  );\n  border: 1px solid rgba(217, 212, 207, 0.4);\n  box-shadow:\n    0 8px 32px rgba(0, 0, 0, 0.12),\n    0 0 0 1px rgba(217, 212, 207, 0.2);\n}\n\n/* Navigation buttons with enhanced touch targets */\nnav[role=\"navigation\"] button {\n  min-height: 44px; /* iOS minimum touch target */\n  min-width: 44px;\n  transition: all 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);\n  position: relative;\n  overflow: hidden;\n  pointer-events: auto;\n  touch-action: manipulation;\n  cursor: pointer;\n  border: none;\n  background: transparent;\n  padding: 0;\n}\n\n/* Touch feedback effect */\nnav[role=\"navigation\"] button:active {\n  animation: icon-press 0.15s cubic-bezier(0.25, 0.46, 0.45, 0.94);\n}\n\n/* Navigation indicator dots */\nnav[role=\"navigation\"] .nav-indicator {\n  transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);\n}\n\n/* Swipe navigation hints (left/right chevrons) */\nnav[role=\"navigation\"] .swipe-hint {\n  animation: fade-in-slide 0.3s ease-out;\n}\n\nnav[role=\"navigation\"] .swipe-hint:disabled {\n  animation: fade-out-slide 0.3s ease-out;\n}\n\n/* Bottom Sheet / More Apps Drawer */\n.mobile-nav-sheet {\n  animation: slide-up-drawer 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);\n}\n\n.mobile-nav-sheet.closing {\n  animation: slide-down-drawer 0.3s ease-in;\n}\n\n/* Bottom Sheet Items Grid */\n.mobile-nav-sheet-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 1rem;\n}\n\n/* Responsive breakpoints for mobile navigation */\n@media (max-width: 480px) {\n  nav[role=\"navigation\"] {\n    padding-left: 0.5rem;\n    padding-right: 0.5rem;\n  }\n\n  .mobile-nav-sheet-grid {\n    grid-template-columns: repeat(3, 1fr);\n    gap: 0.75rem;\n  }\n}\n\n/* Prevent layout shift during safe area adjustment */\n@supports (padding: max(0px)) {\n  nav[role=\"navigation\"] {\n    padding-bottom: max(0.5rem, env(safe-area-inset-bottom));\n  }\n\n  .mobile-page-container {\n    padding-bottom: max(5rem, calc(5rem + env(safe-area-inset-bottom)));\n  }\n}\n\n/* Accessibility: Respect prefers-reduced-motion */\n@media (prefers-reduced-motion: reduce) {\n  *,\n  *::before,\n  *::after {\n    animation-duration: 0.01ms !important;\n    animation-iteration-count: 1 !important;\n    transition-duration: 0.01ms !important;\n    scroll-behavior: auto !important;\n  }\n\n  nav[role=\"navigation\"] {\n    transition: none;\n  }\n\n  nav[role=\"navigation\"] button {\n    transition: none;\n  }\n}\n\n/* Touch device optimizations */\n@media (hover: none) and (pointer: coarse) {\n  nav[role=\"navigation\"] button {\n    /* Increase touch feedback visibility on touch devices */\n    position: relative;\n  }\n\n  nav[role=\"navigation\"] button::after {\n    content: '';\n    position: absolute;\n    inset: 0;\n    background: rgba(14, 165, 233, 0.05);\n    border-radius: inherit;\n    opacity: 0;\n    transition: opacity 0.2s ease;\n    pointer-events: none;\n  }\n\n  nav[role=\"navigation\"] button:active::after {\n    opacity: 1;\n  }\n}\n\n/* High DPI/Retina display support */\n@media (-webkit-min-device-pixel-ratio: 2) {\n  nav[role=\"navigation\"] {\n    border-width: 0.5px;\n  }\n}\n\n/* iPhone X and later notch support */\n@supports (padding: max(0px)) {\n  nav[role=\"navigation\"] {\n    padding-left: max(1rem, env(safe-area-inset-left));\n    padding-right: max(1rem, env(safe-area-inset-right));\n  }\n}\n\n/* Smooth scrolling for main content area */\n.mobile-page-container {\n  -webkit-overflow-scrolling: touch;\n  scroll-behavior: smooth;\n}\n\n/* Page transition animations */\n.page-transition-enter {\n  animation: slide-in-right 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);\n}\n\n.page-transition-exit {\n  animation: slide-out-left 0.3s ease-in;\n}\n\n.page-transition-enter-reverse {\n  animation: slide-in-left 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);\n}\n\n.page-transition-exit-reverse {\n  animation: slide-out-right 0.3s ease-in;\n}\n\n/* Landscape mode optimizations */\n@media (max-height: 500px) {\n  nav[role=\"navigation\"] {\n    padding: 0.5rem 1rem;\n  }\n\n  .mobile-nav-sheet {\n    max-height: 80vh;\n  }\n}\n\n/* Optimize for iPad and larger tablets */\n@media (min-width: 768px) and (max-height: 1024px) {\n  nav[role=\"navigation\"] {\n    padding: 0.75rem 1rem;\n  }\n}\n\n/* Haptic feedback simulation (visual only, actual haptics via JavaScript if available) */\n@keyframes haptic-feedback {\n  0%, 100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.8;\n  }\n}\n\n.haptic-feedback {\n  animation: haptic-feedback 0.1s cubic-bezier(0.25, 0.46, 0.45, 0.94);\n}\n\n/* Focus indicators for keyboard navigation */\nnav[role=\"navigation\"] button:focus-visible {\n  outline: 2px solid var(--cyan-bright);\n  outline-offset: -2px;\n  box-shadow: 0 0 0 2px var(--bg-elevated), 0 0 0 4px var(--cyan-bright);\n}\n\n/* Dark mode - enhanced contrast for mobile nav */\n.dark nav[role=\"navigation\"] {\n  border-top: 1px solid rgba(14, 165, 233, 0.2);\n  border-bottom: 2px solid rgba(155, 139, 126, 0.25);\n}\n\n/* Performance optimization: Use will-change for animated elements */\nnav[role=\"navigation\"] button {\n  will-change: transform, opacity;\n}\n\nnav[role=\"navigation\"] .nav-indicator {\n  will-change: width, background-color;\n}\n\n/* Prevent unnecessary repaints on scroll */\n.mobile-page-container {\n  contain: layout style paint;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
